// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1uLdo","header":"ReportDetails_header__1h6Ce","title":"ReportDetails_title__2KEqR","left":"ReportDetails_left__1o0ka"};